import { Box, Button, Divider, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import {useNavigate} from 'react-router-dom'
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";


    function AboutMain() {
        const navigate = useNavigate()
        const dispatch = useDispatch()
        const allLanguages = useSelector((state) => state.language.languageList)

        const [loading, setLoading] = useState(false)

        const initialListData = {
            Excellent_Location: { heading: '', description: '' },
            Fully_Equipped: { heading: '', description: '' },
            Security: { heading: '', description: '' },
            Social_Space: { heading: '', description: '' },
            Learing_Support: { heading: '', description: '' },
            Social_Activities: { heading: '', description: '' },
            // Mangement_and_Service: { heading: '', description: '' }
        };

        const imageData = {
            Excellent_Location: '',
            Fully_Equipped: '',
            Security: '',
            Social_Space: '',
            Learing_Support: '',
            Social_Activities: '',
            // Mangement_and_Service: '',
          };

        const [images, setImages] = useState({...imageData})
        const [aboutUsData, setAboutUsData] = useState([])

        const [activeLanguages, setActiveLanguages] = useState(allLanguages);
        const [activeLanguagesWhy, setActiveLanguagesWhy] = useState(allLanguages);
        const [activeLanguagesDescription, setActiveLanguagesDescription] = useState(allLanguages);
        const [activeLanguagesList, setActiveLanguagesList] = useState(allLanguages)
        const [activeLanguagesBottom, setActiveLanguagesBottom] = useState(allLanguages)

        const [aboutUsId, setAboutUsId] = useState('')

        const [heading, setHeading] = useState({ en: { heading: '' } });
        const [headerImage, setHeaderImage] = useState({})
        const [description, setDescription] = useState({en : {line1 : '', line2 : '', line3 : ''}})
        const [whyChoose, setWhyChoose] = useState({en : {whyChoose : ''}})
        const [listData, setListData] = useState({en : { ...initialListData }})
        const [bottomData, setBottomData] = useState({en : {Apply_Now : '', Start_new_life : '', fill_form : ''}})
        const [imageMap, setImageMap] = useState({
            Excellent_Location: '',
            Fully_Equipped: '',
            Security: '',
            Social_Space: '',
            Learing_Support: '',
            Social_Activities: '',
            // Mangement_and_Service: '',
          });
        
          // Handle image upload
          const handleImageUpload = (key, file) => {
            if (!file) return;
        
            // Simulate an upload process (replace with actual API call)
            const imageUrl = URL.createObjectURL(file);
        
            setImageMap((prev) => ({
              ...prev,
              [key]: file,
            }));
          };
        
          // Form submit handler (optional)
        //   const handleSubmit = (e) => {
        //     e.preventDefault();
        //     console.log('Uploaded Image Map:', imageMap);
        //   };


        const handleHeadingChange = (e, lang) => {
            setHeading(prev => ({
                ...prev,
                [lang]: { heading: e.target.value }
            }));
        };

        const handleWhyChooseUs = (e, lang) => {
            setWhyChoose(prev => ({
                ...prev, 
                [lang] : {whyChoose : e.target.value}
            }))
        }

        const handleListData = (e, lang, topKey, subKey) => {
            setListData(prev => ({
                ...prev,
                [lang]: {
                    ...prev[lang],
                    [topKey]: {
                        ...prev[lang]?.[topKey],
                        [subKey]: e.target.value
                    }
                }
            }));
        };

        const handleDescriptionChange = (e, lang, line) => {
            setDescription(prev => ({
                ...prev,
                [lang]: {
                    ...prev[lang],
                    [line]: e.target.value
                }
            }));
        };

        const handleBottomDataChange = (e, lang, line) => {
            setBottomData(prev => ({
                ...prev,
                [lang]: {
                    ...prev[lang],
                    [line]: e.target.value
                }
            }));
        }


        const addLanguage = () => {
            const nextLanguage = allLanguages.find(lang => !activeLanguages.some(active => active.value === lang.value));
            if (nextLanguage) {
                setActiveLanguages(prev => [...prev, nextLanguage]);
                setHeading(prev => ({ ...prev, [nextLanguage.value]: { heading: '' } }));
            }
        };

        const addWhyChoose = () => {
            const nextLanguage = allLanguages.find(lang => !activeLanguagesWhy.some(active => active.value === lang.value));
            if (nextLanguage) {
                setActiveLanguagesWhy(prev => [...prev, nextLanguage]);
                setWhyChoose(prev => ({ ...prev, [nextLanguage.value]: { whyChose: '' } }));
            }
        }

        const addDescription = () => {
            const nextLanguage = allLanguages.find(lang => !activeLanguagesDescription.some(active => active.value === lang.value));
            if (nextLanguage) {
                setActiveLanguagesDescription(prev => [...prev, nextLanguage]);
                setDescription(prev => ({
                    ...prev,
                    [nextLanguage.value]: { line1: '', line2: '', line3: '' }
                }));
            }
        };

        const addBottom = () => {
            const nextLanguage = allLanguages.find(lang => !activeLanguagesBottom.some(active => active.value === lang.value));
            if (nextLanguage) {
                setActiveLanguagesBottom(prev => [...prev, nextLanguage]);
                setBottomData(prev => ({
                    ...prev,
                    [nextLanguage.value]: { Apply_Now: '', Start_new_life: '', fill_form: '' }
                }));
            }
        };


        const addListData = () => {
            const nextLanguage = allLanguages.find(lang => !activeLanguagesList.some(active => active.value === lang.value))
            if(nextLanguage){
                setActiveLanguagesList(prev => [...prev, nextLanguage])
                setListData(prev => ({
                    ...prev,
                    [nextLanguage.value] : { ...initialListData }
                }))
            }
        }

        const handleHeaderImageChange = (e) => {
            const file = e.target.files[0];
            if (file && file.type.startsWith('image/')) {
                console.log('Selected image:', file);
                setHeaderImage(file)
            } else {
                alert('Please select a valid image file (e.g., .jpg, .png, .gif)');
            }
        };
        

        const handleSubmit = async () => {
            if(aboutUsData?.length > 0){
                handleSubmitEdit()
            }else{
                const formData = new FormData();

                // Append form data
                formData.append('header', JSON.stringify(heading));
                formData.append('description', JSON.stringify(description));
                formData.append('why_choose', JSON.stringify(whyChoose));
                formData.append('list_data', JSON.stringify(listData));
                formData.append('bottom_card', JSON.stringify(bottomData));
    
                formData.append('header_image', headerImage)
                
                Object.entries(imageMap).forEach(([key, file]) => {
                    if (file instanceof File) {
                      formData.append(key , file);
                    }
                  });
      
                
                setLoading(true)
                try {
                    const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}add-about-us`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                      })
                    console.log(response)
                    if(response.status === 201){
                        console.log(response.data)
                        setLoading(false)
                    }
                } catch (error) {
                    console.log(error)
                    if(error.response.status === 401 || error.response.status === 403){
                        navigate('/Admin/login')
                        dispatch(removeData())
                    }
                    setLoading(false)
                }
            }
        }

        const getAboutUs = async () => {
            try {
                const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-about-us`)
                setAboutUsData(response?.data?.data)
            } catch (error) {
                console.log(error)
                if(error.response.status === 401 || error.response.status === 403){
                    navigate('/Admin/login')
                    dispatch(removeData())
                }
            }
        }

        useEffect(() => {
            getAboutUs()
        }, [])

        useEffect(() => {
            console.log(aboutUsData)
        }, [aboutUsData])
        useEffect(() => {
            if(aboutUsData?.length > 0){
                setHeading(aboutUsData?.[0]?.header)
                setDescription(aboutUsData?.[0]?.description)
                setWhyChoose(aboutUsData?.[0]?.why_choose)
                setListData(aboutUsData?.[0]?.list_data)
                setBottomData(aboutUsData?.[0]?.bottom_card)
                setHeaderImage(`${process.env.REACT_APP_FILE_PATH}/${aboutUsData?.[0]?.images?.header_image}`)
                setImageMap(aboutUsData?.[0]?.images)
                setAboutUsId(aboutUsData?.[0]?._id)
            }
        }, [aboutUsData])
        console.log(aboutUsData.length)

        const handleRemoveHeaderImage = () => {
            setHeaderImage({})
        }

        const updateAboutUs = async (id, formData) => {
            setLoading(true)
            try {
              const response = await axiosInstance.put(`${process.env.REACT_APP_API_URL}edit-about-us/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
              });
              console.log('AboutUs updated successfully:', response);
              getAboutUs()
              setLoading(false)
            } catch (error) {
              console.error('Error updating AboutUs:', error);
              if(error.response.status === 401 || error.response.status === 403){
                navigate('/Admin/login')
                dispatch(removeData())
            }
            setLoading(false)
            }
          };

          
          const handleSubmitEdit = async () => {
            const formData = new FormData();
          
            // Append fields (conditionally if updated)
            formData.append('header', JSON.stringify(heading));
            formData.append('description', JSON.stringify(description));
            formData.append('why_choose', JSON.stringify(whyChoose));
            formData.append('list_data', JSON.stringify(listData));
            formData.append('bottom_card', JSON.stringify(bottomData));

            if (headerImage instanceof File) {
                formData.append('header_image', headerImage);
            }            

          
            // Append images if updated
            Object.entries(imageMap).forEach(([key, file]) => {
              if (file instanceof File) {
                formData.append(key, file);
              }
            });
          
            await updateAboutUs(aboutUsId, formData);
          };
          

        return (
            <Box>
                <Box>
                <Typography sx={{ fontSize: '1.4rem', fontWeight: 700 }}>Heading</Typography>
                
                <Typography sx={{mt : 2, mb : 1}}>Header Image</Typography>
                {headerImage?.length > 0 ? (
                    <Box sx={{display : 'flex', alignItems : 'center', position : 'relative'}}>
                    <Box component='img' sx={{width : '100px', height : '100px'}} src={headerImage} alt='headerimage' />
                    <span onClick={() => handleRemoveHeaderImage()} className='bg-red-600 cursor-pointer text-white font-bold absolute top-[-12px] left-[5rem] p-1 px-3 rounded-full'>X</span>
                    </Box>
                ) : (
                    <TextField type='file' onChange={handleHeaderImageChange} />
                )}
               
                {activeLanguages.map((lang) => (
                    <Box key={lang.value} sx={{ display: 'flex', gap: 5, justifyContent : 'center',alignItems: 'center', mt: 2 }}>
                        <Typography sx={{width : '20%', color : 'black'}}>
                                {lang.name}
                        </Typography>

                        <TextField
                            value={heading[lang.value]?.heading || ''}
                            onChange={(e) => handleHeadingChange(e, lang.value)}
                            placeholder={`Enter heading for ${lang.name}`}
                        />
                    </Box>
                ))}

                
                </Box>
                
                <Divider sx={{mt : 2, mb : 2}}/>
                
                <Typography sx={{ fontSize: '1.4rem', fontWeight: 700 }}>Description</Typography>

                {activeLanguagesDescription.map((lang) => (
                    <Box key={lang.value} sx={{ display: 'flex', mb : 4,flexDirection : 'column', gap: 2, mt: 2 }}>
                        <Typography sx={{ color : 'black', fontWeight : 700, fontSize : '1.1rem'}}>
                                {lang.name}
                        </Typography>

                        <TextField
                            rows={4}
                            multiline
                            value={description[lang.value]?.line1 || ''}
                            onChange={(e) => handleDescriptionChange(e, lang.value, 'line1')}
                            placeholder={`Enter description for line1 ${lang.name}`}
                        />

                        <TextField
                        rows={4}
                        multiline
                            value={description[lang.value]?.line2 || ''}
                            onChange={(e) => handleDescriptionChange(e, lang.value, 'line2')}
                            placeholder={`Enter description for line2 ${lang.name}`}
                        />

                        <TextField
                        rows={4}
                        multiline
                            value={description[lang.value]?.line3 || ''}
                            onChange={(e) => handleDescriptionChange(e, lang.value, 'line3')}
                            placeholder={`Enter description for line2 ${lang.name}`}
                        />
                    </Box>
                ))}

            

            <Divider  sx={{mt : 2, mb : 2}} />

            <Typography sx={{ fontSize: '1.4rem', fontWeight: 700 }}>Why Choose Us</Typography>

            {activeLanguagesWhy.map((lang) => (
                    <Box key={lang.value} sx={{ display: 'flex', gap: 5, justifyContent : 'center',alignItems: 'center', mt: 2 }}>
                        <Typography sx={{width : '20%', color : 'black'}}>
                                {lang.name}
                        </Typography>

                        <TextField
                            value={whyChoose[lang.value]?.whyChoose || ''}
                            onChange={(e) => handleWhyChooseUs(e, lang.value)}
                            placeholder={`Enter why choose us for ${lang.name}`}
                        />
                    </Box>
                ))}

           

            <Divider sx={{mt : 2, mb : 2}}/>

            <Typography sx={{ fontSize: '1.4rem', fontWeight: 700 }}>List Data</Typography>

            {activeLanguagesList.map((lang) => (
                <Box key={lang.value} sx={{ mt: 2 }}>
                    <Typography sx={{ fontSize: '1.2rem', fontWeight: 600, width : '20%' }}>{lang.name}</Typography>

                    {Object.entries(listData[lang.value] || {}).map(([key, value]) => (
                        <Box key={key} sx={{ display: 'flex', gap: 3, alignItems: 'center', mt: 1 }}>
                            <Typography sx={{ width: '40%', color: 'black' }}>{key.replace(/_/g, ' ')}</Typography>
                            <TextField
                                value={value.heading}
                                onChange={(e) => handleListData(e, lang.value, key, 'heading')}
                                placeholder={`Enter heading for ${key.replace(/_/g, ' ')}`}
                            />
                            <TextField
                                value={value.description}
                                multiline
                                row={2}
                                onChange={(e) => handleListData(e, lang.value, key, 'description')}
                                placeholder={`Enter description for ${key.replace(/_/g, ' ')}`}
                            />
                        </Box>
                    ))}
                </Box>
            ))}

           

          


            <Divider sx={{mt : 2, mb : 2}}/>
                
            <div>
                <Typography sx={{fontSize : '1.5rem', fontWeight : 700}}>Upload Images</Typography>
                    {Object.entries(imageMap).filter(([key]) => key !== 'header_image').map(([key, value]) => (
                    <div key={key} style={{ marginBottom: '20px', marginTop : '20px' }}>
                        <label>
                        {key.replaceAll('_', ' ')}:
                        <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageUpload(key, e.target.files[0])}
                        />
                        </label>
                        {value?.length > 0 && (
                        <div style={{ marginTop: '10px' }}>
                            <img src={`${process.env.REACT_APP_FILE_PATH}/${value}`} alt={key} style={{ maxWidth: '200px' }} />
                        </div>
                        )}
                    </div>
                    ))}
                </div>

            <Divider sx={{mt :2, mb : 2}}/>

            <Typography sx={{ fontSize: '1.4rem', fontWeight: 700 }}>Bottom Card</Typography>

            {activeLanguagesBottom.map((lang) => (
                    <Box key={lang.value} sx={{ display: 'flex', mb : 4,flexDirection : 'column', gap: 2, mt: 2 }}>
                        <Typography sx={{ color : 'black', fontWeight : 700, fontSize : '1.1rem'}}>
                                {lang.name}
                        </Typography>

                        <TextField
                            value={bottomData[lang.value]?.Apply_Now || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'Apply_Now')}
                            placeholder={`Enter for Apply Now ${lang.name}`}
                        />

                        <TextField
                            value={bottomData[lang.value]?.Start_new_life || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'Start_new_life')}
                            placeholder={`Enter for Start new life ${lang.name}`}
                        />

                        <TextField
                            value={bottomData[lang.value]?.fill_form || ''}
                            onChange={(e) => handleBottomDataChange(e, lang.value, 'fill_form')}
                            placeholder={`Enter for fill form ${lang.name}`}
                        />
                    </Box>
                ))}

              

                <Box>
                <Button disabled={loading} variant="contained" onClick={() => handleSubmit()}  sx={{ mt: 2 }}>{aboutUsData?.length > 0 ? 'Update' : 'Save'}</Button>
                </Box>
            </Box>
        );
    }

    export default AboutMain;
